import { Button, Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useGetUser from "../../../hooks/users/useGetUsers";
import { IUser } from "../../../service/user/interfaces/IUser";
import useDeleteUser from "../../../hooks/users/useInactiveUser";
import {
  Edit,
  Refresh,
  Add,
  Send,
  CancelScheduleSend,
  Block,
  Done,
  Face,
  Close,
} from "@mui/icons-material";
import { Tooltip, Stack, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import DataGridCustom from "../../../components/DataGridCustom";
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import DialogCustom from "../../../components/DialogCustom/DialogCustom";

interface IHooksUser {
  data: IUser | any;
  error: any;
  isLoading: boolean;
}

function UserListPage() {
  const navigate = useNavigate();
  const { deleteUserHooks } = useDeleteUser();
  const [reload, setReload] = useState(false);
  const { data, error, isLoading }: IHooksUser = useGetUser(reload);
  const [user, setUsers] = useState<IUser[]>([]);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);
  useEffect(() => {
    try {
      setUsers(data);
    } catch {
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, data]);

  const handleOpenDialog = (user: any) => {
    setSelectedUser(user);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleInactivateUser = (publicId: string) => {
    deleteUserHooks(publicId).then((resp) => {
      handleCloseDialog();
      setReload((prevReload) => !prevReload);
    });
  };

  const columns: GridColDef[] = [
    {field: "idUsuario",  headerName: "ID", width: 100},
    { field: "nome", headerName: "Nome", width: 200 },
    { field: "perfil", headerName: "Perfil", width: 150 },
    { field: "titulo", headerName: "Titulo", width: 150 },
    { field: "email", headerName: "Endereço de e-mail", width: 300 },
    {
      field: "contato",
      headerName: "Contato",
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      description:
        "Esta coluna tem um renderCell de valor e não pode ser classificada ou filtrada.",
      valueFormatter: (params) => (params.value ? "Sim" : "Não"),
      renderCell: (params) => {
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            sx={{ width: "100%" }}
          >
            {params.row.contato ? (
              <Tooltip title="Sim">
                <Send color="info" />
              </Tooltip>
            ) : (
              <Tooltip title="Não">
                <CancelScheduleSend color="warning" />
              </Tooltip>
            )}
          </Stack>
        );
      },
    },

    {
      field: "ativo",
      headerName: "Status",
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      description:
        "Esta coluna tem um renderCell de valor e não pode ser classificada ou filtrada.",
      valueFormatter: (params) => (params.value ? "Ativo" : "Inativo"),
      renderCell: (params) => {
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            sx={{ width: "100%" }}
          >
            {params.row.ativo ? (
              <Tooltip title="Ativo">
                <Done color="success" />
              </Tooltip>
            ) : (
              <Tooltip title="Inativo">
                <Close color="error" />
              </Tooltip>
            )}
          </Stack>
        );
      },
    },
    {
      field: "actions",
      headerName: "Opções",
      sortable: false,
      filterable: false,
      disableExport: true,
      headerAlign: "center",
      align: "center",
      description:
        "Esta coluna tem um renderCell de valor e não pode ser classificada ou filtrada.",
      width: 150,
      renderCell: (params) => {
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  navigate(`/user-edit/${params.row.publicId}`);
                }}
                color="info"
              >
                <Edit />
              </IconButton>
            </Tooltip>
            <Tooltip title="Inativar">
              <IconButton
                onClick={() => {
                  handleOpenDialog(params.row);
                }}
                color="error"
              >
                <Block />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Chip icon={<Face color="warning" />} label="Utilizadores" />
      </Grid>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <DataGridCustom
          rows={user}
          getRowId={(row: any) => row.idUsuario}
          columns={columns}
          loading={isLoading}
          pageSize={20}
          customButton={
            <React.Fragment>
              <Button
                color="warning"
                startIcon={<Add />}
                size="small"
                onClick={() => navigate("/user-register")}
              >
                Adicionar Utilizador
              </Button>

              <Button
                startIcon={<Refresh />}
                size="small"
                onClick={() => setReload(!reload)}
              >
                Atualizar
              </Button>
            </React.Fragment>
          }
        />
      </Grid>
      <DialogCustom
        user={selectedUser}
        open={openDialog}
        handleClose={handleCloseDialog}
        handleInactivate={handleInactivateUser}
        primaryButton="Cancelar"
        secondaryButton="Inativar"
      />
    </Grid>
  );
}

export default UserListPage;
